import React from "react";
import parse from "html-react-parser";

export default function Hero({ blog }) {
  return (
    <div className="row p-0 flex-column-reverse flex-lg-row align-items-center">
      {/* Text Section */}
      <div className="col-12 col-lg-6 d-flex flex-column justify-content-center text-start">
        <h1 className="mb-3 mt-2">{blog?.title}</h1>
        <p className="mb-4"
          dangerouslySetInnerHTML={{ __html: blog?.short_description }}
        ></p>
      </div>

      {/* Image Section */}
      <div className="col-12 pt-2  col-lg-6 d-flex justify-content-center">
        <img
          src={`${blog?.image?.data?.attributes?.url}`}
          alt={blog?.title}
          className="img-fluid"
          style={{ maxWidth: "100%", height: "400px", objectFit: "cover" }}
        />
      </div>
    </div>
  );
}
